import { countryList } from "@/locales/properNouns";
import messages from "./json/ja.json";

export default {
  "pl": {
    word: "{n} {word}",
  },
  "validation": {
    alpha: "{_field_} にはアルファベットのみ",
    alpha_num: "{_field_} には英数字のみ",
    alpha_dash: "{_field_} には英数字、ダッシュ、アンダーバーのみ",
    alpha_spaces: "{_field_} には英数字、スペースのみ",
    between: "{_field_} は {min} から{max}の間でお願いします",
    confirmed: "{_field_} の確認が取れません",
    digits: "{_field_} は {length} 桁を含む正確な数値でお願いします",
    dimensions: "{_field_} は{width} pixels × {height} pixelsでお願いします",
    email: "{_field_} には有効なメールアドレスでお願いします",
    excluded: "{_field_} は有効な値ではありません",
    ext: "{_field_} は有効なファイルではありません",
    image: "{_field_} は画像でお願いします",
    integer: "{_field_} は整数でお願いします",
    length: "{_field_} の長さは {length} でお願いします",
    max_value: "{_field_} は {max} 以下でお願いします",
    max: "{_field_} の文字数は {length} 文字以内でお願いします",
    mimes: "{_field_} は有効なファイルタイプでお願いします",
    min_value: "{_field_} は{min} 以上が必要です",
    min: "{_field_} は {length} 文字以上が必要です",
    numeric: "{_field_} には数字のみを入力できます",
    oneOf: "{_field_} は有効な値ではありません",
    regex: "{_field_} は無効なフォーマットです",
    required_if: "{_field_} は必須項目です",
    required: "{_field_} は必須項目です",
    size: "{_field_} のサイズは {size}KB以下でお願いします",
    credit_card: "{_field_} は有効なカード番号でお願いします",
    required_select: "{_field_} は必須項目です",
  },
  "notificationsText": {
    liked: "{screenName} があなたの投稿を気に入っています",
    followed: "{screenName} があなたをフォローしました",
    subscribed: "{screenName} が  {price}で購入しました",
    upgradeSubscription: "{screenName} がサブスクをアップグレードしました。サブスクレベルは {price}です",
    soldPost: "{screenName} があなたの投稿を {price}で購入しました",
    soldAttachment: "{screenName} があなたの投稿を {price}で購入しました",
    soldEvent: "{screenName} has booked your event {date} for {price}",
    eventPublished: "Upcoming event by {screenName}!",
    eventStarted: "The event has started",
    eventCancelled: "{screenName} canceled the event",
  },
  ...messages,
  ...countryList,
  "United States of America": "アメリカ合衆国",
  "Canada": "カナダ",
  "Afghanistan": "アフガニスタン",
  "Algeria": "アルジェリア",
  "Samoa": "サモア",
  "Andorra": "アンドラ",
  "Angola": "アンゴラ",
  "Anguilla": "アンギラ",
  "Antarctica": "南極",
  "Antigua and Barbuda": "アンティグアバーブーダ",
  "Argentina": "アルゼンチン",
  "Armenia": "アルメニア",
  "Aruba": "アルバ",
  "Australia": "オーストラリア",
  "Austria": "オーストリア",
  "Azerbaijan": "アゼルバイジャン",
  "Bahamas": "バハマ",
  "Bahrain": "バーレーン",
  "Bangladesh": "バングラデシュ",
  "Barbados": "バルバドス",
  "Belgium": "ベルギー",
  "Belize": "ベリーズ",
  "Benin": "ベニン",
  "Bermuda": "バミューダ",
  "Bhutan": "ブータン",
  "Bolivia, Plurinational State of": "ボリビア、多国籍国家",
  "Bonaire, Sint Eustatius and Saba": "ボネール、シントユースタティウス島とサバ島",
  "Botswana": "ボツワナ",
  "Bouvet Island": "ブーベ島",
  "Brazil": "ブラジル",
  "British Indian Ocean Territory": "英領インド洋地域",
  "Brunei Darussalam": "ブルネイダルサラーム",
  "Burkina Faso": "ブルキナファソ",
  "Cabo Verde": "カーボベルデ",
  "Cambodia": "カンボジア",
  "Cameroon": "カメルーン",
  "Cayman Islands": "ケイマン諸島",
  "Chad": "チャド",
  "Chile": "チリ",
  "China": "中国",
  "Christmas Island": "クリスマス島",
  "Cocos (Keeling) Islands": "ココス（キーリング）諸島",
  "Colombia": "コロンビア",
  "Comoros": "コモロ",
  "Congo": "コンゴ",
  "Cook Islands": "クック諸島",
  "Costa Rica": "コスタリカ",
  "Curaçao": "キュラソー",
  "Cyprus": "キプロス",
  "Czechia": "チェコ",
  "Denmark": "デンマーク",
  "Djibouti": "ジブチ",
  "Dominica": "ドミニカ",
  "Dominican Republic": "ドミニカ共和国",
  "Ecuador": "エクアドル",
  "Egypt": "エジプト",
  "El Salvador": "エルサルバドル",
  "Equatorial Guinea": "赤道ギニア",
  "Eritrea": "エリトリア",
  "Estonia": "エストニア",
  "Eswatini": "エスワティニ",
  "Ethiopia": "エチオピア",
  "Falkland Islands (Malvinas)": "フォークランド諸島（マルビナス）",
  "Faroe Islands": "フェロー諸島",
  "Fiji": "フィジー",
  "Finland": "フィンランド",
  "France": "フランス",
  "French Guiana": "仏領ギアナ",
  "French Polynesia": "フランス領ポリネシア",
  "French Southern Territories": "フランス領南方南方領土",
  "Gabon": "ガボン",
  "Gambia": "ガンビア",
  "Germany": "ドイツ",
  "Ghana": "ガーナ",
  "Gibraltar": "ジブラルタル",
  "Greece": "ギリシャ",
  "Greenland": "グリーンランド",
  "Grenada": "グレナダ",
  "Guadeloupe": "グアドループ",
  "グアム": "グアム",
  "Guatemala": "グアテマラ",
  "Guernsey": "ガーンジー",
  "Guinea": "ギニア",
  "Guinea-Bissau": "ギニアビサウ",
  "Guyana": "ガイアナ",
  "Haiti": "ハイチ",
  "Heard Island and McDonald Islands": "ハード島とマクドナルド諸島",
  "Holy See": "バチカン",
  "Honduras": "ホンジュラス",
  "Hong Kong": "香港",
  "Hungary": "ハンガリー",
  "Iceland": "アイスランド",
  "India": "インド",
  "Indonesia": "インドネシア",
  "Ireland": "アイルランド",
  "Isle of Man": "マン島",
  "Israel": "イスラエル",
  "Italy": "イタリア",
  "Jamaica": "ジャマイカ",
  "Japan": "日本",
  "Jersey": "ジャージー",
  "Jordan": "ジョーダン",
  "Kazakhstan": "カザフスタン",
  "Kenya": "ケニア",
  "Kiribati": "キリバス",
  "Korea, Republic of": "大韓民国",
  "Kuwait": "クウェート",
  "Kyrgyzstan": "キルギスタン",
  "Lao People's Democratic Republic": "ラオス人民民主共和国",
  "Latvia": "ラトビア",
  "Lesotho": "レソト",
  "Libya": "リビア",
  "Liechtenstein": "リヒテンシュタイン",
  "Lithuania": "リトアニア",
  "Luxembourg": "ルクセンブルグ",
  "Macao": "マカオ",
  "Madagascar": "マダガスカル",
  "Malawi": "マラウイ",
  "Malaysia": "マレーシア",
  "Maldives": "モルディブ",
  "Malta": "マルタ",
  "Marshall Islands": "マーシャル諸島",
  "Martinique": "マルティニーク",
  "Mauritania": "モーリタニア",
  "Mauritius": "モーリシャス",
  "Mayotte": "マヨット",
  "Mexico": "メキシコ",
  "Micronesia, Federated States of": "ミクロネシア連邦",
  "Monaco": "モナコ",
  "Mongolia": "モンゴル",
  "Montserrat": "モントセラト",
  "Morocco": "モロッコ",
  "Mozambique": "モザンビーク",
  "Myanmar": "ミャンマー",
  "Namibia": "ナミビア",
  "Nauru": "ナウル",
  "Nepal": "ネパール",
  "Netherlands": "オランダ",
  "New Caledonia": "ニューカレドニア",
  "New Zealand": "ニュージーランド",
  "Niger": "ニジェール",
  "Nigeria": "ナイジェリア",
  "Niue": "ニウエ",
  "Norfolk Island": "ノーフォーク島",
  "Norway": "ノルウェー",
  "Oman": "オマーン",
  "Pakistan": "パキスタン",
  "Palau": "パラオ",
  "Palestine, State of": "パレスチナ、州",
  "Panama": "パナマ",
  "Papua New Guinea": "パプアニューギニア",
  "Paraguay": "パラグアイ",
  "Peru": "ペルー",
  "Philippines": "フィリピン",
  "Pitcairn": "ピトケアン",
  "Poland": "ポーランド",
  "Portugal": "ポルトガル",
  "Qatar": "カタール",
  "Russian Federation": "ロシア連邦",
  "Rwanda": "ルワンダ",
  "Réunion": "レユニオン",
  "Saint Barthélemy": "サンバルテルミー",
  "Saint Helena, Ascension and Tristan da Cunha": "セントヘレナ、アセンションとトリスタンダクーニャ",
  "Saint Kitts and Nevis": "セントクリストファー・ネイビス",
  "Saint Lucia": "セントルシア",
  "Saint Martin, (French part)": "サンマルタン、（フランスの部分）",
  "Saint Pierre and Miquelon": "サンピエール島とミクロン島",
  "Saint Vincent and the Grenadines": "セントビンセントおよびグレナディーン諸島",
  "San Marino": "サンマリノ",
  "Sao Tome and Principe": "サントメ・プリンシペ",
  "Saudi Arabia": "サウジアラビア",
  "Senegal": "セネガル",
  "Seychelles": "セイシェル",
  "Sierra Leone": "シエラレオネ",
  "Singapore": "シンガポール",
  "Sint Maarten, (Dutch part)": "シントマールテン、（オランダの部分）",
  "Slovakia": "スロバキア",
  "Slovenia": "スロベニア",
  "Solomon Islands": "ソロモン諸島",
  "South Africa": "南アフリカ",
  "South Georgia and the South Sandwich Islands": "サウスジョージアとサウスサンドイッチ諸島",
  "South Sudan": "南スーダン",
  "Spain": "スペイン",
  "Sri Lanka": "スリランカ",
  "Suriname": "スリナム",
  "Svalbard and Jan Mayen": "スバールバル諸島およびヤンマイエン",
  "Sweden": "スウェーデン",
  "Switzerland": "スイス",
  "Taiwan, Province of China": "台湾、中国省",
  "Tajikistan": "タジキスタン",
  "Tanzania, United Republic of": "タンザニア、連合共和国",
  "Thailand": "タイ",
  "Timor-Leste": "東ティモール",
  "Togo": "トーゴ",
  "Tokelau": "トケラウ",
  "Tonga": "トンガ",
  "Trinidad and Tobago": "トリニダード・トバゴ",
  "Tunisia": "チュニジア",
  "Turkey": "トルコ",
  "Turkmenistan": "トルクメニスタン",
  "Turks and Caicos Islands": "タークス・カイコス諸島",
  "Tuvalu": "ツバル",
  "Uganda": "ウガンダ",
  "United Arab Emirates": "アラブ首長国連邦",
  "United Kingdom of Great Britain and Northern Ireland": "グレートブリテンおよび北アイルランド連合王国",
  "United States Minor Outlying Islands": "合衆国領有小島",
  "Uruguay": "ウルグアイ",
  "Uzbekistan": "ウズベキスタン",
  "Vanuatu": "バヌアツ",
  "Venezuela, Bolivarian Republic of": "ベネズエラ、ボリバル共和国",
  "Viet Nam": "ベトナム",
  "Virgin Islands, British": "英領バージン諸島",
  "Virgin Islands, U.S.": "米領バージン諸島",
  "Wallis and Futuna": "ウォリス・フツナ",
  "Western Sahara": "西サハラ",
  "Zambia": "ザンビア",
  "Åland Islands": "オーランド諸島",
};
